import styled, { css, keyframes } from "styled-components";
import { theme } from "ui/themes";
import { Container } from "ui";
import { DescriptionParcels } from "../../components/BoxPriceProduct/styles";
import { Button } from "../../components/ButtonCart/styles";

interface BoxInfoMobileProps {
  shouldAlignToRight?: boolean;
  isBlackTheme?: boolean;
  activeButtonWeddingList?: boolean;
}

const showMoreSoftly = keyframes`
from {
  opacity: 0;
}

to {
  opacity: 1;
}
`;

export const Header = styled.header<BoxInfoMobileProps>`
  position: fixed;
  top: 0;
  background: ${theme.colors.neutral.white};
  width: 100vw;
  max-height: fit-content;
  overflow: hidden;
  display: none;
  z-index: 12;
  padding-top: 0.8rem;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 10%);

  animation: ${showMoreSoftly} 0.125s ease-in;

  ${({ isBlackTheme }) =>
    isBlackTheme &&
    css`
      background-color: ${theme.colors.blackFriday["175"]} !important;
    `}

  @media ${theme.device.desktopFirst.tabletS} {
    bottom: 0;
    top: auto;
    box-shadow: 0px -2px 3px 0px rgb(0 0 0 / 10%);
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    bottom: -1px;
    top: auto;
    box-shadow: 0px -2px 3px 0px rgb(0 0 0 / 10%);
  }
`;

export const HeaderContent = styled(Container)`
  padding: 0 0 0.65rem 1.5rem;
`;

export const SectionContainer = styled.section<BoxInfoMobileProps>`
  display: flex;
  max-width: 45%;

  @media ${theme.device.desktopFirst.mobileXL} {
    align-items: ${({ shouldAlignToRight }) =>
      shouldAlignToRight ? "center" : "flex-start"} !important;
  }
`;

export const BoxButtons = styled.div<BoxInfoMobileProps>`
  display: flex;
  flex-direction: ${({ activeButtonWeddingList }) =>
    activeButtonWeddingList ? "row-reverse" : "column"};
  align-items: ${({ activeButtonWeddingList }) =>
    activeButtonWeddingList ? "center" : "end"};
  justify-content: center;
  gap: 1.5rem;
  width: max-content;

  //artur.castro essa media query muito especifica para ajuste futuro
  @media (min-width: 1025px) {
    flex-direction: ${({ activeButtonWeddingList }) =>
      activeButtonWeddingList ? "column" : "row"};
    padding: ${({ activeButtonWeddingList }) =>
      activeButtonWeddingList ? "0rem 2rem 0 0" : "1rem 2rem 0 0"};
  }

  @media ${theme.device.mobileFirst.mobileXL} {
    flex-direction: ${({ activeButtonWeddingList }) =>
      activeButtonWeddingList ? "column" : "row"};
    gap: 0.5rem;
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    gap: 0.5rem;

    ${Button} {
      height: ${({ activeButtonWeddingList }) =>
        activeButtonWeddingList ? "36px" : "38px"};
      width: ${({ activeButtonWeddingList }) =>
        activeButtonWeddingList ? "56px" : "116px"};
    }
  }
`;

export const BoxInfo = styled.div<BoxInfoMobileProps>`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 2.5rem;

  ${SectionContainer}:first-child {
    display: flex;
    align-items: center !important;
    gap: 1rem;
  }

  ${SectionContainer}:last-child {
    align-items: flex-end;
    gap: 2rem;
  }

  @media ${theme.device.mobileFirst.tabletS} {
    ${SectionContainer}:first-child {
      flex-direction: row;
    }

    ${SectionContainer}:last-child {
      flex-direction: column;
      align-items: flex-end;
      max-width: 50%;
      gap: 0;
    }
  }

  @media ${theme.device.mobileFirst.laptop} {
    ${SectionContainer}:first-child {
      flex-direction: row;
    }

    ${SectionContainer}:last-child {
      gap: 2rem;
      flex-direction: row;
      align-items: flex-start;
    }
  }

  @media ${theme.device.desktopFirst.tabletS} {
    ${SectionContainer}:first-child {
      flex-direction: row;
    }

    ${SectionContainer}:last-child {
      flex-direction: column;
    }
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    ${SectionContainer}:first-child {
      display: flex;
      align-items: flex-start !important;
      gap: 1rem;
      padding-right: 1.5rem;
    }

    ${SectionContainer}:last-child {
      align-items: flex-end !important;
      padding-right: 1.5rem;
      gap: 1rem;
    }
  }
`;

export const ValueProduct = styled.h3`
  font-size: 1.5rem;
  color: ${theme.colors.primary["200"]};
`;

export const BoxValueDescription = styled.section`
  text-align: end;

  ${DescriptionParcels} {
    text-align: right !important;
  }

  @media ${theme.device.mobileFirst.mobileXL} {
    padding-right: 2rem;
  }

  @media ${theme.device.mobileFirst.laptop} {
    padding-right: 0;
  }
`;

export const BoxImage = styled.div`
  min-width: 7rem;
  max-width: 7rem;
  height: 7rem;
  margin-right: 1rem;

  img {
    border-radius: 8px;
    padding: 4px;
    background: ${theme.colors.neutral.white};
  }

  @media ${theme.device.desktopFirst.tabletS} {
    margin-top: 0;
    margin-right: 0;
    min-width: 5rem;
    max-width: 6rem;
    display: flex;
    align-items: center;

    span {
      padding: 0.75rem !important;
    }
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    min-width: 4rem;
    max-width: 4rem;
    padding-bottom: 2rem;

    span {
      padding: 0.75rem !important;
    }
  }
`;

export const BoxNav = styled.nav<BoxInfoMobileProps>`
  display: flex;
  justify-content: flex-start;
  gap: 2rem;
  position: relative;
  top: 7px;

  a {
    font-size: 1.2rem;
    color: ${theme.colors.neutral["600"]};
    cursor: pointer;
    padding: 1rem 0 0.25rem 0;
    ${({ isBlackTheme }) =>
      isBlackTheme &&
      css`
        color: ${theme.colors.blackFriday.white} !important;
      `}
  }

  @media ${theme.device.desktopFirst.tabletS} {
    display: none;
  }

  .active {
    border-bottom: 2px solid ${theme.colors.primary["200"]};

    ${({ isBlackTheme }) =>
      isBlackTheme &&
      css`
        border-bottom: 2px solid ${theme.colors.secondary["310"]} !important;
      `};

    color: ${theme.colors.primary["200"]};
  }
`;

export const Description = styled.text<BoxInfoMobileProps>`
  color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? theme.colors.blackFriday.white
      : theme.colors.neutral["600"]};

  font-size: 1.45rem;
  min-width: 156px;
  max-width: 156px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  white-space: pre-wrap;
  user-select: none;
  font-weight: 600;

  @media ${theme.device.mobileFirst.laptop} {
    max-width: 476px;
    padding-top: 1rem;
    align-self: normal;
  }

  @media ${theme.device.desktopFirst.mobileM} {
    min-width: 124px;
    font-size: 1.45rem;
  }

  @media ${theme.device.desktopFirst.mobileS} {
    font-size: 1.25rem;
  }
`;
